import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emailFormatter',
  pure: false,
})
export class EmailFormatterPipe implements PipeTransform {
  transform(value: string, masked: boolean): string {
    if (!value) {
      return value;
    }

    if (!masked) {
      return value;
    }

    const indexOfAtSymbol =
      value.indexOf('@') >= 0 ? value.indexOf('@') : value.length - 1;

    let markedStr = '';
    for (let i = 0; i < value?.length; i++) {
      if (i < 1 || i >= indexOfAtSymbol) {
        markedStr += value[i];
      } else {
        markedStr += '*';
      }
    }

    return markedStr;
  }
}
